<template>
  <v-card>
    <v-form ref="form" :lazy-validation="true">
      <v-card-title>ÄNDRA KVALIFICERINGSTID</v-card-title>
      <v-card-actions>
        <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
      </v-card-actions>
      <v-card-text class="">
        <h6 class="text-uppercase semi-bold pb-1 mt-n4">Ändra startdatum</h6>
        <DatePicker
          ref="startDate"
          v-model="startDate"
          :icon="'$sl-calendar'"
          width="250px"
          outlined
          :disabled="modificationIsPending"
        />
      </v-card-text>
      <v-card-text class="">
        <h6 class="text-uppercase semi-bold pb-1 mt-n5">Ändra längd</h6>
        <v-select
          v-model="qualificationLength"
          :items="timesLengths"
          outlined
          item-text="text"
          item-value="id"
          return-object
          label="Kvalificeringstidens längd"
          clearable
          :disabled="modificationIsPending"
        ></v-select>
        <!-- <p>Startdatum: {{ education.qualificationTime.fromDate | date }}</p> -->

        <MessageBox type="info" v-if="modificationIsPending">
        <p>Det är inte möjligt att förlänga just nu pga att det redan ligger en förlängning för godkännande hos regionen.</p>
      </MessageBox>

        <template v-else>
          <p class="mt-2" v-if="endDate">Förväntat slutdatum för kvalificeringstid på {{ `${ get(qualificationLength, 'value', 0) || 24 } månader` }}: {{ endDate | date }}</p>
          <p class="caption">Eventuella uppehåll har inte tagits med i beräkningen.</p>
          <p class="body-3 mt-6">
            <a
              href="https://www.byggbranschensyrkesnamnd.se/om-byn/yrkesutbildningsavtal/yua-2020-avtal-och-anvisningar/"
              target="blank"
              ><v-icon class="mr-2" size="18px">$sl-info</v-icon>Beräkning av kvalificeringstid</a
            >
          </p>
        </template>
        
        <template v-if="get(this, 'qualificationLength.value', 0) > agreementLength">
          <MessageBox type="alert" class="mt-n2">
            <p>
              Längden du angivit överstiger den avtalsbaserade tiden.
            </p>
          </MessageBox>
        </template>

      </v-card-text>

      <v-card-actions class="justify-end mt-2">
        <v-btn @click="$emit('close')"> <v-icon>$sl-cancel</v-icon>AVBRYT </v-btn>
        <v-btn color="secondary" @click="saveNewLengthDate" :disabled="!canUpdate || modificationIsPending"> <v-icon>$sl-edit</v-icon>ÄNDRA </v-btn>
      </v-card-actions>
    </v-form>
    <v-dialog persistent v-model="saveModalVisible" max-width="420px">
      <v-card flat>
        <v-icon class="close" @click.prevent="saveModalVisible=false">$sl-close</v-icon>
        <p class="pt-5">Ändringen är registrerad och behöver nu godkännas av ytterligare en regionär. Du kan se din ändring under lärlingens ärende-flik.</p>
        <div class="d-flex justify-end pb-2 pt-4">
          <v-btn
              :block="false"
              class=""
              smallerText
              @click="saveModalVisible = false;"
              actionIcon="$sl-save"
              :disabled="modificationIsPending"
          >Fortsätt</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import API from '@/services/api.js'
import DatePicker from '@/components/common/DatePicker'
import get from 'lodash/get'
import MessageBox from '@/components/common/MessageBox.vue'
import {CanIDo} from '@/components/mixins'

// @group K-Tid
// ChangeTimeModal component
export default {
  name: 'ChangeTimeModal',
  mixins: [CanIDo],
  props: {
    propQualificationTime: {
      type: Object,
      // Object or array defaults must be returned from
      // default empty
      default: function () {
        return {}
      }
    },
    propProfessionId: Number,
    paused: {
      type: Array,
      // Object or array defaults must be returned from
      // default empty
      default: function () {
        return []
      }
    }
  },

  components: {
    DatePicker,
    MessageBox
  },

  data() {
    return {
      qualificationLength: 24,
      timesLengths: [],
      startDate: null,
      agreementLength: null,
      saveModalVisible: false,
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapGetters('basic', ['getQualificationLengthItems']),
    ...mapGetters('person', ['selectedPerson']),
    ...mapGetters('basic', ['getProfessionById']),
    ...mapGetters('currentuser', ['currentUser']),

    endDate() {
      let fromDate = new Date(get(this, 'propQualificationTime.fromDate', null))
      let toDate = new Date(get(this,'propQualificationTime.toDate', null))
      // let pausedDates = 0
      // if (this.paused && this.paused.length > 0) {
      //   this.paused.forEach(pause => {
      //     pausedDates += this.monthDiff(new Date(pause.fromDate), new Date(pause.toDate))
      //   })
      // }
      if (this.qualificationLength && get(this,'qualificationLength.value', null)) {
        let finalTime = get(this,'qualificationLength.value', null)
        return fromDate.setMonth(fromDate.getMonth() + finalTime)
      } else {
        return toDate
      }
    },

    modificationIsPending() {
      return get(this, 'propQualificationTime.qualificationTimeModifications', []).some(({ rejected, approved }) => !rejected && !approved)
    },

    roleIsRegionary() {
      return get(this, 'currentUser.userrole.isRegionary', false)
    },

    modificationLengthLimit() {
      if ( this.roleIsRegionary ) {
        let limit = 6
        let totalModificationLengthCount = get(this, 'propQualificationTime.qualificationTimeModifications', []).reduce((sum, item) => sum + item.lengthInMonths, 0)

        if ( totalModificationLengthCount > this.agreementLength ) {
          totalModificationLengthCount = totalModificationLengthCount - this.agreementLength
        }

        return limit - totalModificationLengthCount
      }
      return get(this, 'numberOfMonths', []).length
    },

    numberOfMonths() {
      let timesLengths = []
      let months = this.currentQualifyingLength * 2

      for (let i = 0; i <= months; i++) {
        timesLengths.push({id: i, text: i + ' månader', value: i})
      }

      /*
      if ( this.roleIsRegionary ) {
        timesLengths = timesLengths.slice((this.currentQualifyingLength-(this.modificationLengthLimit)), (this.currentQualifyingLength+(this.modificationLengthLimit + 1)))
      }
        */

      return timesLengths
    },

    currentQualifyingLength() {
      return this.monthDiff(new Date(this.propQualificationTime.fromDate), new Date(this.propQualificationTime.toDate))
    }
  },

  asyncComputed: {
    canUpdate(){
      return this.canIDo('education', 'update');
    },
  },

  methods: {
    get: get,

    init() {
      this.startDate = new Date().toISOString().substr(0, 10)

      if(!this.propQualificationTime)
        return

      if(this.propQualificationTime && this.propQualificationTime.fromDate)
      {
        this.startDate=this.propQualificationTime.fromDate
      }

      if(this.propQualificationTime.fromDate && this.propQualificationTime.toDate){
        let monthDiff = this.currentQualifyingLength
        this.qualificationLength = this.numberOfMonths.find(m => m.value == monthDiff) || this.currentQualifyingLength
      }

      this.agreementLength = 36

      try {
        let profList = this.getProfessionById(this.propProfessionId)?.qualificationTimeLength
        if ( typeof profList === 'string' )
          profList = JSON.parse(profList)

        let baseLength = profList[this.propProfessionId].length
        const tcs = get(this, 'selectedPerson.tradeCertificates', [])
        tcs.forEach(tc => {
          const tradeCertificateId = get(tc, 'profession.id', null)
          if(tradeCertificateId) {
            const tcLength = profList[tradeCertificateId].length
              if (tcLength < baseLength) {
                baseLength = tcLength
              }
          }
        })
        
        this.agreementLength = baseLength || profList[length]
      } catch(e) {
        console.log(e)
      }

      this.timesLengths = this.numberOfMonths.map((t) => {
        let text =t.text
        if(t.value==get(this,'qualificationLength.value', this.qualificationLength)) {
          text = text + ' (oförändrad)'
        }
        else if(get(this,'qualificationLength.value', this.qualificationLength) > t.value) {
          let diff = get(this,'qualificationLength.value', this.qualificationLength) - t.value
          if(diff==1)
            text = text + ' (' + diff + ' månad kortare)'
          else
            text = text + ' (' + diff + ' månader kortare)'
        }
        else {
        let diff = t.value - get(this,'qualificationLength.value', this.qualificationLength)
          if(diff==1)
            text = text + ' (' + diff + ' månad längre)'
          else
            text = text + ' (' + diff + ' månader längre)'
        }

        return {
          id: t.id,
          text: text,
          value: t.value,
        }}).reverse()

    },

    saveNewLengthDate() {

      if(!(this.qualificationLength && this.qualificationLength.value && this.propQualificationTime && this.propQualificationTime.id))
      {
        this.$emit('close')
        return
      }

      let createObject = {
        fromDate: this.startDate,
        newLengthInMonths: get(this,'qualificationLength.value', 0),
        qualificationTimeId: this.propQualificationTime.id
      }

      API.createQualificationTimeModification({data: createObject})
        .then(response => {
          //this.$refs.form.reset()
          // this.$events.fire('showInfo', 'Skickad för godkännande.')
          this.$emit('close')
          this.saveModalVisible = true
        })
        .catch(error => {
          console.log('Error: ', error)
          this.$events.fire('showError', 'Tyvärr gick det inte att spara.')
        })
    },

    monthDiff(d1, d2) {
      var months
      months = (d2.getFullYear() - d1.getFullYear()) * 12
      months -= d1.getMonth()
      months += d2.getMonth()
      return months <= 0 ? 0 : months
    }
  }
}
</script>
